/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { InfoButton } from '@/domain/mitarbeiter/shared/components/InfoButton';
import { ZuschlagsgruppeSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Zuschlaege/ZuschlagsgruppeSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Alert,
  Body,
  Heading,
  RadioGroup,
  RadioGroupItem,
  Skeleton,
  Title,
} from '@e2n/ui/v2';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function Zuschlaege() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <form.Subscribe
      selector={(state) => ({
        zuschlaege: state.values.bezahlung.zuschlaege,
      })}>
      {({ zuschlaege }) => (
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-4">
            <div className="flex gap-1 items-center">
              <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
              <InfoButton>
                <Body>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.info',
                  )}
                </Body>
              </InfoButton>
            </div>
            <form.AppField
              name="bezahlung.zuschlaege.zuschlaege"
              listeners={{
                onChange: () => {
                  ctx.resetDependentFields('bezahlung.zuschlaege.zuschlaege');
                },
              }}>
              {(field) => (
                <FieldBase>
                  <RadioGroup
                    value={field.state.value?.toString()}
                    onValueChange={(e) => {
                      field.handleChange(e === 'true');
                    }}
                    className="flex flex-row">
                    <RadioGroupItem
                      variant="card"
                      layout="horizontal"
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlaege.options.true',
                      )}
                      value={'true'}
                      className="w-full"
                    />
                    <RadioGroupItem
                      variant="card"
                      layout="horizontal"
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlaege.options.false',
                      )}
                      value={'false'}
                      className="w-full"
                    />
                  </RadioGroup>
                </FieldBase>
              )}
            </form.AppField>
          </div>

          {zuschlaege.zuschlaege && (
            <>
              <div className="flex flex-col gap-4">
                <Title>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.description',
                  )}
                </Title>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
                  <Suspense fallback={<Skeleton className="w-full h-10" />}>
                    <ZuschlagsgruppeSelect />
                  </Suspense>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <Accordion type="single" collapsible>
                  <AccordionItem value="options">
                    <AccordionTrigger>
                      <Title>
                        {t(
                          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.optionen',
                        )}
                      </Title>
                    </AccordionTrigger>
                    <AccordionContent className="pt-4">
                      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
                        <form.AppField
                          name="bezahlung.zuschlaege.pauschaleZuschlaege"
                          listeners={{
                            onChange: () => {
                              ctx.validateCurrentSubStep();
                            },
                          }}>
                          {(field) => (
                            <field.MoneyInput
                              label={t(
                                'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.pauschaleZuschlaege.label',
                              )}
                            />
                          )}
                        </form.AppField>
                        <form.AppField
                          name="bezahlung.zuschlaege.uebertariflicheZahlung"
                          listeners={{
                            onChange: () => {
                              ctx.validateCurrentSubStep();
                            },
                          }}>
                          {(field) => (
                            <field.MoneyInput
                              label={t(
                                'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.uebertariflicheZahlung.label',
                              )}
                            />
                          )}
                        </form.AppField>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
                <form.Subscribe
                  selector={(state) =>
                    state.fieldMeta['bezahlung.zuschlaege']?.errorMap?.onSubmit
                  }>
                  {(error) =>
                    error ? (
                      <Alert
                        variant="error"
                        showIcon
                        title={t(
                          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.validationErrorAlert.title',
                        )}
                        description={t(
                          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.validationErrorAlert.description',
                        )}></Alert>
                    ) : null
                  }
                </form.Subscribe>
              </div>
            </>
          )}
        </div>
      )}
    </form.Subscribe>
  );
}
